import { IAreaDimension } from '../data/dimension/dimension';
import { EEntityType } from '../types';
import { AreaDimensionModel } from './2d/areaDimensionModel';
import BaseEntity from './BaseEntity';

export class AreaDimensionEntity extends BaseEntity<EEntityType.AreaDimension> {
  private _areaDimension: IAreaDimension;

  protected override _model2d: AreaDimensionModel;
  private _hover: boolean;

  constructor(areaDimension: IAreaDimension) {
    super({
      type: EEntityType.AreaDimension,
      id: areaDimension.id
    });

    this._areaDimension = areaDimension;
    this._model2d = new AreaDimensionModel(areaDimension);
    this._hover = false;
  }

  get areaDimension() {
    return this._areaDimension;
  }

  set hover(hover: boolean) {
    if (this._hover === hover) return;

    this._hover = hover;
    this._model2d.setHover(hover);
  }

  get hover() {
    return this._hover;
  }

  override set selected(selected: boolean) {
    if (this._selected === selected) return;

    this._selected = selected;
    this._model2d.setSelected(selected);
  }

  override get selected() {
    return this._selected;
  }

  setVisible(visible: boolean) {
    if (this._visible === visible) return;

    this._visible = visible;
    this._model2d.setVisible(visible);
  }

  getVisible() {
    return this._visible;
  }

  override update(areaDimension: IAreaDimension) {
    this._areaDimension = areaDimension;
    this._model2d.updateModel(areaDimension);
    this._model2d.setHover(this._hover);
    this._model2d.setSelected(this._selected);
  }
}
